<div class="goals-overview-box">
  <h3 class="percentage" [countTo]="stats.progress" [countToDuration]="1000" data-test-id="overview-modal-progress-percentage">0</h3>
  <h1>{{ "progress_cap" | localize }}</h1>
  <h2>
    {{ "mean_for_objectives" | localize : { percentage: sessionPeriodPassedPercentageString } }}
  </h2>
</div>
<div class="goals-overview-box">
  <h3 class="warning" [countTo]="stats.daysToDeadline" [countToDuration]="1000" data-test-id="overview-modal-days-to-deadline">0</h3>
  <h1>{{ "days_deadline" | localize }}</h1>
  <h2>{{ "deadline_on" | localize }} {{ session.end | date : "dd MMMM, yyyy" }}.</h2>
</div>
<div class="goals-overview-box">
  <h3 [countTo]="stats.goalCount" [countToDuration]="1000" data-test-id="overview-modal-objectives-total-number">0</h3>
  <h1>{{ "objectives" | localize }}</h1>
  <h2>{{ "total_number_key_results_set" | localize }}</h2>
</div>
<div class="goals-overview-box">
  <h3 class="positive" [countTo]="stats.goalsMetCount" [countToDuration]="500" data-test-id="overview-modal-goals-met-count">0</h3>
  <h1>
    <span *ngIf="stats.goalsMetCount === 0">{{ "key_results_hit" | localize }}</span>
    <a *ngIf="stats.goalsMetCount > 0" (click)="navigateToList('goals-hit')">{{ "key_results_hit" | localize }}</a>
  </h1>
  <h2>{{ "total_number_key_results" | localize }}</h2>
</div>
<div class="goals-overview-box">
  <h3 [countTo]="stats.metricsCount" [countToDuration]="1000" data-test-id="overview-modal-metrics-count">0</h3>
  <h1>{{ "metrics" | localize }}</h1>
  <h2>{{ "total_number_okrs_set" | localize }}</h2>
</div>
<div class="goals-overview-box">
  <h3 class="positive" [countTo]="stats.metricsMetCount" [countToDuration]="1000" data-test-id="overview-modal-metrics-met-count">0</h3>
  <h1>
    <span *ngIf="stats.metricsMetCount === 0">{{ "okrs_hit" | localize }}</span>
    <a *ngIf="stats.metricsMetCount > 0" (click)="navigateToList('metrics-hit')">{{ "okrs_hit" | localize }}</a>
  </h1>
  <h2>{{ "total_number_okrs_hit_adv" | localize }}</h2>
</div>
<div class="goals-overview-box">
  <h3 class="positive" [countTo]="stats.goodMetricsCount" [countToDuration]="500" data-test-id="overview-modal-good-metrics-count">0</h3>
  <h1>
    <span *ngIf="stats.goodMetricsCount === 0">{{ "okrs_going_well" | localize }}</span>
    <a *ngIf="stats.goodMetricsCount > 0" (click)="navigateToList('metrics-going-well')">{{ "okrs_going_well" | localize }}</a>
  </h1>
  <h2>{{ "total_number_okrs_on_track" | localize }}</h2>
</div>
<div class="goals-overview-box">
  <h3 class="negative" [countTo]="stats.badMetricsCount" [countToDuration]="500" data-test-id="overview-modal-bad-metrics-count">0</h3>
  <h1>
    <span *ngIf="stats.badMetricsCount === 0">{{ "objectives_in_danger" | localize }}</span>
    <a class="negative" *ngIf="stats.badMetricsCount > 0" (click)="navigateToList('metrics-in-danger')">{{ "objectives_in_danger" | localize }}</a>
  </h1>
  <h2>{{ "total_number_okrs_unlikely" | localize }}</h2>
</div>
<div class="goals-overview-box">
  <h3 [countTo]="stats.dynamicMetricCount" [countToDuration]="1000" data-test-id="overview-modal-dynamic-metrics-count">0</h3>
  <h1>
    <span *ngIf="stats.dynamicMetricCount === 0">{{ "dynamic_krs" | localize }}</span>
    <a *ngIf="stats.dynamicMetricCount > 0" (click)="navigateToList('dynamic-metrics')">{{ "dynamic_krs" | localize }}</a>
  </h1>
  <h2>{{ "auto_update_okrs" | localize }}</h2>
</div>
<div class="goals-overview-box">
  <h3 [countTo]="stats.manualMetricCount" [countToDuration]="1000" data-test-id="overview-modal-manual-metrics-count">0</h3>
  <h1>
    <span *ngIf="stats.manualMetricCount === 0">{{ "manual_okrs" | localize }}</span>
    <a *ngIf="stats.manualMetricCount > 0" (click)="navigateToList('manual-metrics')">{{ "manual_okrs" | localize }}</a>
  </h1>
  <h2>{{ "manual_update_okrs" | localize }}</h2>
</div>
